export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_s_01_f.1dba8673.png";